import { Box, Image, Link } from '@chakra-ui/react'
import React from 'react'
import { CompanyType } from 'src/types/types'
import { links, logos } from './constants'

interface CompanyHeaderProps {
  sender: CompanyType
}

const CompanyHeader: React.FC<CompanyHeaderProps> = ({ sender }) => {
  if (!logos[sender]) return null

  return (
    <Box>
      <Link href={links[sender]} isExternal>
        <Image src={logos[sender]} alt={sender} height='76' width='186' />
      </Link>
    </Box>
  )
}

export default CompanyHeader
